<template>
  <RevContainer>
    <RevCardCarousel
      :next-alternative-text="i18n(translations.alternativeNext)"
      :prev-alternative-text="i18n(translations.alternativePrevious)"
      size="extra-small"
      :title="i18n(translations.sectionTitle)"
    >
      <button
        v-for="category in categories"
        :key="category.name"
        class="flex flex-col items-start gap-8"
        type="button"
        @click="handleCategoryClick(category.name)"
      >
        <RevIllustration
          :alt="category.label"
          class="rounded-lg"
          :height="144"
          :src="category.image"
          :width="256"
        />
        <span class="heading-3">
          {{ category.label }}
        </span>
      </button>
    </RevCardCarousel>
  </RevContainer>
</template>

<script setup lang="ts">
import type { BuybackCategory } from '@backmarket/nuxt-layer-buyback/composables/useBuybackCategories/useBuybackCategories'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevCardCarousel } from '@ds/components/CardCarousel'
import { RevContainer } from '@ds/components/Container'
import { RevIllustration } from '@ds/components/Illustration'

import translations from './SeoCategories.translations'

const i18n = useI18n()

defineProps<{
  categories: BuybackCategory[]
}>()

const emit = defineEmits<{
  'category-click': [categoryName: string]
}>()

function handleCategoryClick(categoryName: string) {
  emit('category-click', categoryName)
}
</script>
